import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Icon from "@mui/material/Icon";
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import { Stack } from "@mui/material";
import { makeStyles, useTheme } from '@mui/material/styles';
import { ToastContainer, toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import { ThreeDots } from 'react-loader-spinner';
import { useDropzone } from "react-dropzone";
import { useDropzone2 } from "react-dropzone";
import "layouts/style.css";
import { Bars } from 'react-loader-spinner'
import Select from "react-select"
import { saveCustomerFormUploads } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import { updateCustomerPortalUploads } from "assets/globalAPI/apiGlobal";

const CustomerFormNextEdit = () => {   
    
        const navigate= useNavigate();
        const [loaderspinner, setLoaderSpinner] = useState(false);
        const [isActive, setIsActive] = useState(false);
        const [isMsme, setIsMsme] = useState(false);
        const [isfssi, setIsFssi] = useState(false);
        const [customerType, setCustomerType] = useState("");
        const toastId = React.useRef(null);
        const [loader, setLoader] = useState(false);
        const [formSubmitted, setIsFormSubmiteed] = useState(false);
        const [declaration, setDeclartion]= useState(false)
        const [refID,setRefID]= useState(localStorage.getItem("reference_id"))
        const contactEmail= localStorage.getItem("contactPersonEmail")
        const contactMobile= localStorage.getItem("contactPersonMobile")

        const [formValues, setFormValues] = useState({
            reference_id: refID,
              pan_card_document: null, 
              fssai_document: null, 
              tan_document: null, 
              gstin_document:null, 
              cancel_cheque_document: null, 
              undated_security_cheques_document: null, 
              address_proof_document: null, 
              declaration: "I Agree",

        
              
            });

            const [formValues2,setFormValues2] = useState({
                reference_id: refID,
                pan_card_document: null, 
                fssai_document: null, 
                tan_document: null, 
                gstin_document:null, 
                cancel_cheque_document: null, 
                undated_security_cheques_document: null, 
                address_proof_document: null, 
                
            })


            const fetchVendors=async(refId)=>{
                                  
                              
                                  let body;
                              
                                 
                                    body={
                                      page:1,
                                      reference_id: refId 
                                    }
                                    console.log("fetching customers with body>> ", body)
                                  try{
                                    const response= await fetchAllCustomer(body);
                                    const res= response.data;
                                    if(res.status){
                                      console.log("Vendors fetched>> ", res.data);
                                      const newValues = { ...formValues2 };
                          
                                      Object.keys(newValues).forEach(key => {
                                          if (res.data[0].hasOwnProperty(key)) {
                                              newValues[key]=res.data[0][key];
                                          }
                                      });
                                      newValues.reference_id= refId
                                      console.log("here are vals>> ", newValues)
                                    //   setFormValues(newValues);
                                      setFormValues2(newValues)
                                     
                                    }else{
                                      console.log("Could not fetch customer>> ", res);
                                      
                                    }
                                  }catch(err){
                                    console.log("Error bringing vendors>> ", err);
                                    if(err.response?.status==403){
                                      if(!toast.isActive(toastId.current)){
                                        toastId.current= toast.error(err.response.data.message,{
                                          className:"small-toast"
                                        })
                                      }
                                      setTimeout(()=>{
                                        navigate("/")
                                      },2000)
                                    }
                                  }
                                }

         

               useEffect(() => {
                const isAuthenticate= localStorage.getItem("isAuthenticated");
      if(!isAuthenticate){
        navigate("/customer/edit/validation");
        return;
      }
                let refid= localStorage.getItem("reference_id")
                console.log("reference_id>> ", refid)
                fetchVendors(refid)
                              let filledForm= localStorage.getItem("customerForm");
                              console.log("printing form from previous page>>> ", JSON.parse(filledForm))
                              // console.log("the previous form>> ", JSON.parse(filledForm))
                              setFormValues2(JSON.parse(filledForm));
                            },[]);

                            const handleFormChange = (field, value) => {
                              let updatedValue = value;
                              console.log("here is a file>> ", value);
                          
                              // Handle file inputs properly
                              if (field.endsWith("_document") && value instanceof File) {
                                  updatedValue = value; // Store the file object directly
                              }
                          
                              setFormValues((prevState) => ({
                                  ...prevState,
                                  [field]: updatedValue, // Just set the value, don't wrap in an object
                                  reference_id: refID // Ensure refID is always set
                              }));
                          };
                          

            const handlePreviousPage=()=>{
                navigate("/customer/edit/registration-form");
                
            }

             const handleSubmitForm=async(e)=>{
                              e.preventDefault();
                              setIsActive(true)
                                const requiredFields = [
                                                  "pan_card_document" 
                                                ];
                              
                                                let hasError = false;
                                  let updatedValues = { ...formValues };
                                  let updates2= {...formValues2}


                                  for (let key in formValues2) {
                                    if (
                                      key !== "reference_id" &&
                                      key !== "declaration" &&
                                      key !== "pan_card_document" &&
                                      formValues2[key]!== null &&
                                      formValues2[key]!== "" &&
                                      (updatedValues[key]== null || updatedValues[key]== "")
                                    ) {
                                      requiredFields.push(key);
                                    }
                                  }
                                
                                  requiredFields.forEach(key => {
                                    
                                    if (!updatedValues[key]) {
                                     
                                      hasError = true;
                                    }
                                  });
                                  // const docFields = [
                                  //   "fssai_document",
                                  //   "tan_document",
                                  //   "address_proof_document",
                                  //   "gstin_document",
                                  //   "cancel_cheque_document",
                                  //   "undated_security_cheques_document"
                                  // ];
                                  
                                  
                                  
                                  // docFields.forEach(key => {
                                  //   const fromAPI = formValues2[key]?.value;
                                  //   const fromUser = formValues[key]?.value;
                                  
                                  //   if (fromAPI !== "" && (!fromUser || fromUser === "")){
                                  //     hasError = true;
                                  //   }
                                  // });
                              
                                  if (hasError) {
                                    console.log("form1>> ", formValues);
                                    console.log("form2>> ", formValues2);
                                    console.log("cannot submit, fill mandatory")
                                    console.log("requires fields are>> ", requiredFields)
                                   
                                    if (!toast.isActive(toastId.current)) {
                                      toastId.current = toast.error("Please Fill All The Required Fields", {
                                        className: "small-toast"
                                      });
                                    }
                              
                                    setIsActive(false)
                                    
                                    return;
                                  }
                              console.log("final formValues>> ", formValues)
                              const formData= new FormData();

                              const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
                                                            
                                                            for (let key in formValues) {
                                                              if(key=="declaration"|| key=="reference_id"){
                                                                continue; // Skip declaration and reference_id
                                                              }
                                                              const file = formValues[key];
                                                              if (file) {
                                                                if (!allowedTypes.includes(file.type)) {
                                                                  if (!toast.isActive(toastId.current)) {
                                                                    toastId.current = toast.error(`File types must be PDF or Image (JPG/PNG).`, {
                                                                      className: "small-toast"
                                                                    });
                                                                  }
                                                                  // alert(`File type for ${key} must be PDF or Image (JPG/PNG).`);
                                                                  setIsActive(false);
                                                                  return;
                                                                }
                                                              }
                                                            }
            
                              Object.keys(formValues).forEach(key => {
                                if (formValues[key]) {
                                    formData.append(key, formValues[key]); // Append file
                                }
                            });
            
                              // Object.entries(formValues).forEach(([key, obj]) => {
                              //   if (Array.isArray(obj.value)) {
                              //     obj.value.forEach((val, index) => {
                              //       formData.append(`${key}[${index}]`, val);
                              //     });
                              //   } else {
                              //     formData.append(key, obj.value);
                              //   }
                              // });
            
                              formData.forEach((value, key) => {
                                console.log(`${key}: ${value}`);
                              });
            
                              try{
                                const response= await updateCustomerPortalUploads(formData);
                                const res= response.data;
                                console.log("Here is upload response>> ", res);
                                if(res.status){
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.success("Updation Successful",{
                                              className: "small-toast"
                                            })
                                  }
                                  setIsFormSubmiteed(true);
                                  // setIsActive(false)
                                formData.forEach((value, key) => {
                                  console.log(`${key}: ${value}`);
                                });
                                setTimeout(()=>{
            
                                  navigate("/customer/edit/validation")
                              }, 3000)
                                } else{
                                  if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.warning("Could Not Register",{
                                              className: "small-toast"
                                            })
                                  }
                                  console.log("why not register>> ", res)
                                  setIsActive(false)
                                }
                              }catch(err){
                                console.log("Error uploading files>> ", err)
                                if(!toast.isActive(toastId.current)){
                                  toastId.current= toast.error("Registration Error",{
                                            className: "small-toast"
                                          })
                                }
                                setIsActive(false)
                              }
                               
                                
                                        // localStorage.removeItem("filledForm2");
                                        // localStorage.setItem("filledForm", JSON.stringify(formValues))
            
                                
                              }

            return(
                <>
                <ToastContainer/>
                <SimpleBackdrop openLoader={isActive} />
                <Grid>
                <SoftBox py={0} className="customerblock">
   <Grid container spacing={3}>
   <Grid item xs={12} lg={12} className="headerForm">
   
   <SoftBox p={0} display="flex" alignItems="center" justifyContent="space-between">
<img src={anmolLogo} alt="Logo" style={{ height: 100 }} />

<SoftTypography  variant="h3" id="form_heading" style={{ flex: 1, textAlign: "center" }}>
Customer Edit
</SoftTypography>

{/* This empty box ensures the text remains centered */}
<div style={{ width: 50 }}></div>
</SoftBox>


   <Grid>
                 {loaderspinner ? <div style={{
                   position: 'fixed', width: "100%", height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)',
                   zIndex: 200000, display: 'flex', justifyContent: 'center', alignItems: 'center', top: '0px', left: '0px',
                 }}>
                   <ThreeDots color="#fff" height={50} width={50} timeout={1000} visible={loaderspinner} />

                 </div> : ""}
   </Grid>
   
   </Grid>
   </Grid>
   </SoftBox>

    <SoftBox className="bp formBG">
        <form noValidate onSubmit={handleSubmitForm}>
        <SoftBox py={3} className="customerblock">
       <Grid container spacing={3}>
         <Grid item xs={12} lg={12}>
           <Card sx={{ overflow: "visible" }}>
             <SoftBox p={3}>
               <SoftTypography variant="h5" id="form_heading textUppercase">Upload Documents</SoftTypography>

               <SoftTypography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
                 * Only PDF or images (JPG, JPEG, PNG) are allowed with max size upto 5MB.<br/><br/>
                 * Files that were previously uploaded are mandatory to upload again.
               </SoftTypography>

               <SoftBox mt={1}>
                 <Grid container spacing={3}>
                 <Grid item xs={12} sm={4}>
                     <SoftBox mb={3}>
                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                         <SoftTypography
                           component="label"
                           variant="caption"
                           fontWeight="bold"
                           textTransform="capitalize"
                         >
                           FSSAI License Document{formValues2?.fssai_document && <span > *</span>}
                         </SoftTypography>
                       </SoftBox>
                       <SoftInput  
                         type="file"
                        //  disabled={formValues2.fssai_license_document?.value !== "Active"}
                        //  value={formValues.latest_co_status.value}
                        //  onChange={(e) => {
                        //   console.log("ffsai license is is>>> ", e.target.files[0])
                        //   handleFormChange('fssai_document', e.target.files[0])}}
                        onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("fssai_document", file);
                                                      return;
                                                    }
                                                    console.log("fssai file is>>> ", file);
                                                    handleFormChange("fssai_document", file);
                                                  }
                        } }
                         placeholder="Street"
                         id="street"
                         size="medium" />
                        {
  formValues2?.fssai_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.fssai_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                     </SoftBox>
                   </Grid>
                 <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                              <SoftTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold"
                                                textTransform="capitalize"
                                              >
                                                Pan Card Document*.
                                              </SoftTypography>
                                            </SoftBox>
                                            <SoftInput
                                              type="file"
                                              id="tds_doc"
                                              // disabled={formValues.tds_exemption?.value !== "Yes"}
                                            //   error={formValues.tds_doc.error}
                                              // value={formValues.tds_doc.value}
                                              // onChange={(e) => {
                                              //   console.log("pan file is>>> ", e.target.files[0])
                                              //   handleFormChange('pan_card_document', e.target.files[0])}}
                                              onChange={(e) =>{
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                          const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                                          if (!allowedTypes.includes(file.type)) {
                                                                            if(!toast.isActive(toastId.current)){
                                                                              toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                                        className: "small-toast"
                                                                                      })
                                                                            }
                                                                            handleFormChange("pan_card_document", file);
                                                                            return;
                                                                          }
                                                                          console.log("fssai file is>>> ", file);
                                                                          handleFormChange("pan_card_document", file);
                                                                        }
                                              } }
                                            />
                                            {
  formValues2?.pan_card_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.pan_card_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                          </SoftBox>
                                        </Grid>
                    <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3} id="mkcustomer">
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  GSTIN Document*
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                size="medium"
                                                name="gstn_document"
                                                id="gstn_document"
                                                // error={formValues.gstn_document.error}
                                                // value={formValues.gstn_document.value}
                                                // onChange={(e) =>{
                                                //   console.log("gstin file is>>> ", e.target.files[0])
                                                // handleFormChange('gstin_document', e.target.files[0])}}
                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("gstin_document", file);
                                                      return;
                                                    }
                                                    console.log("fssai file is>>> ", file);
                                                    handleFormChange("gstin_document", file);
                                                  }
                        } }
                                              />
                                              {
  formValues2?.gstin_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.gstin_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                          </SoftBox>
                                          </Grid>
                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  TAN Document{formValues2?.tan_document && <span > *</span>}
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // error={formValues.pan_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("tan file is>> ", e.target.files[0])
                                                //     handleFormChange('tan_document', e.target.files[0])
                                                // } }

                                                    onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("tan_document", file);
                                                      return;
                                                    }
                                                    console.log("fssai file is>>> ", file);
                                                    handleFormChange("tan_document", file);
                                                  }
                        } }
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                             {
  formValues2?.tan_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.tan_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  Cancel Cheque{formValues2?.cancel_cheque_document && <span > *</span>}
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.msme_registration_status?.value === ""}
                                                // error={formValues.msme_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("cancel cheque file is>> ", e.target.files[0])
                                                //     handleFormChange('cancel_cheque_document', e.target.files[0])
                                                // } }

                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("cancel_cheque_document", file);
                                                      return;
                                                    }
                                                    console.log("fssai file is>>> ", file);
                                                    handleFormChange("cancel_cheque_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                             {
  formValues2?.cancel_cheque_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.cancel_cheque_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  3 Undated Security Cheque & Covering Letter{formValues2?.undated_security_cheques_document && <span > *</span>}
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.fssai_registration_status?.value === ""}
                                                // error={formValues.fssai_document.error}
                                                // value={formValues.pan_document.value}
                                                // onChange={(e) =>{
                                                //     console.log("undated cheque file is>> ", e.target.files[0])
                                                //     if(!toast.isActive(toastId.current)){
                                                //                             toastId.current= toast.warning("NOTE: You Must Also Submit Physical copy of undated security cheques",{
                                                //                                       className: "small-toast"
                                                //                                     })
                                                //                           }
                                                //     handleFormChange('undated_security_cheques_document', e.target.files[0])
                                                // } }
                                                onChange={(e) =>{
                                                  const file = e.target.files[0];
                                                  if (file) {
                                                    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                                                    if (!allowedTypes.includes(file.type)) {
                                                      if(!toast.isActive(toastId.current)){
                                                        toastId.current= toast.warning("Only PDF or images (JPG, JPEG, PNG) are allowed",{
                                                                  className: "small-toast"
                                                                })
                                                      }
                                                      handleFormChange("undated_security_cheques_document", file);
                                                      return;
                                                    }
                                                    console.log("fssai file is>>> ", file);
                                                    handleFormChange("undated_security_cheques_document", file);
                                                  }
                        } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                             {
  formValues2?.undated_security_cheques_document ? (
    <a 
      href={`https://anmolmdm-backend.arodek.com/${formValues2.undated_security_cheques_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                            </SoftBox>
                                          </Grid>

                                          <Grid item xs={12} sm={4}>
                                          <SoftBox mb={3}>
                                              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <SoftTypography
                                                  component="label"
                                                  variant="caption"
                                                  fontWeight="bold"
                                                  textTransform="capitalize"
                                                >
                                                  Address Proof{formValues2?.address_proof_document && <span > *</span>}
                                                </SoftTypography>
                                              </SoftBox>
                                              <SoftInput
                                                type="file"
                                                name="pan"
                                                id="pan"
                                                // disabled={formValues2.fssai_registration_status?.value === ""}
                                                // error={formValues.address_proof_document.error}
                                                // value={formValues.pan_document.value}
                                                onChange={(e) =>{
                                                    console.log("address file is>> ", e.target.files[0])
                                                    handleFormChange('address_proof_document', e.target.files[0])
                                                } }
                                                
                                                size="medium"
                                                // inputProps={{ maxLength: "15" }}
                                              />
                                              {
  formValues2?.address_proof_document ? (
    <a 
      href={`https://crm-backend.anmolindustries.com/${formValues2.address_proof_document}`} 
      target="_blank" 
      download 
      style={{ fontWeight: 'bold', fontSize: "12px" }} 
      rel="noopener noreferrer"
    >
      View File
    </a>
  ) : null
}

                                            </SoftBox>
                                          </Grid>

                 </Grid>
               </SoftBox>
                 <SoftBox py={3} className="customerblock">

                 <Grid container spacing={3}>
                 <Card sx={{ overflow: "visible" }}>
                    <SoftBox p={3}>
                        <div style={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
<input 
// style={{marginTop:'10px'}}
type="checkbox" 
style={{ cursor: "pointer", marginTop:'10px' }} 
checked={declaration} 
onChange={(e) => setDeclartion(e.target.checked)} 
/>
<SoftTypography variant="h5" id="form_heading">
<span style={{ fontSize: "12px" }}>
I/W<span style={{textTransform: 'lowercase'}}>e</span> <span style={{textTransform: 'lowercase'}}> hereby certify that the information provided by me / us in this sheet and all attachments hereto are true and correct to the best of my / our knowledge and hereby authorize Anmol Industries Limited to check all information contained herein by whatever means finds appropriate. I / We understand that any falsification of documents and any fraudulent information or misrepresentation will serve as grounds for nullification of this application. Upon signing this Application, I / We also agree to the terms and conditions in the enclosed attachement. </span>
</span>
</SoftTypography>
</div>
<Grid container display="flex" justifyContent="space-between" mt={2} >
<Grid item>
       <SoftButton onClick={handlePreviousPage} variant="contained" color="success">
         Previous
       </SoftButton>
     </Grid>
     <Grid item>
       <SoftButton disabled={!declaration} type="submit" variant="contained" color="primary">
         Save & Submit
       </SoftButton>
     </Grid>
   </Grid>
                    </SoftBox>
                 </Card>
                 </Grid>
                 </SoftBox>


             
               

               

             </SoftBox>
           </Card>
         </Grid>
       </Grid>
     </SoftBox>
        </form>
    </SoftBox>
                </Grid>
                </>
            )
}

export default CustomerFormNextEdit;